import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Outlet } from 'react-router';
import classNames from 'classnames';
import { isMobile } from 'react-device-detect';
import { Icons } from '../base/BootstrapComponents/BootstrapComponents';
import Loader from '../base/Loader/Loader';
import Notifications from '../../modules/Notifications/components/Notifications';
import GlobalConfirmModal from '../../modules/System/components/GlobalConfirmModal';
import { getSystemData } from '../../modules/System/reducer';
import { getLoginProcess } from '../../modules/Authorized/reducer';
import { InformationFormWrapper } from '../../modules/InformationScreenWrapper/components/InformationFormWrapper';
import SignPopup from '../../modules/System/components/SignPopup';
import ProcessProgressBar from '../../modules/System/components/ProcessProgressBar';
import MobileMiniProfile from './MobileMiniProfile';

export default function MobileLayout({ currentRoutesByMenu }) {
  const [lowVisionMode, setLowVisionMode] = useState(false);
  const [showMenu, setShowMenu] = useState(false);
  const loginProcess = useSelector(getLoginProcess);
  const { loadApp } = useSelector(getSystemData);

  useEffect(() => {
    window.addEventListener('scroll', window.customEventListener.emit, { capture: true });
    window.addEventListener('mouseup', window.customEventListener.emit, { capture: true });
    return () => {
      window.removeEventListener('scroll', window.customEventListener.emit);
      window.removeEventListener('mouseup', window.customEventListener.emit);
    };
  }, []);

  useEffect(() => {
    document.documentElement.style.fontSize = lowVisionMode ? '20px' : '16px';
  }, [lowVisionMode]);

  return (
    <div className={classNames('main-layout', { 'low-vision-mode': lowVisionMode })}>
      <Notifications />
      <Loader loading={loginProcess || loadApp} global hideScreen={loadApp} />
      <div className="app-container">
        <div className="app-content-wrapper custom-scroll-theme">
          <div className="app-content" id="app-content">
            <div className="app-bar mobile-app-bar">
              <div className="mobile-logo">
                <Icons customIcon className="toggle-button logo-full" icon="logo-full" />
              </div>
              <div className="mobile-menu-button" onClick={() => setShowMenu(true)}>
                <Icons customIcon className="mobile-menu" icon="mobile-menu" />
              </div>
              {showMenu ? <MobileMiniProfile currentRoutesByMenu={currentRoutesByMenu} onHide={() => setShowMenu(false)} lowVisionMode={lowVisionMode} setLowVisionMode={setLowVisionMode} /> : null}
            </div>
            <div className="app-content-children" id="app-content-children">
              <div className="page-wrapper custom-scroll-theme">
                <Outlet />
              </div>
              <InformationFormWrapper />
            </div>
            <div className="app-content-footer" id="app-content-footer" />
          </div>
        </div>
      </div>
      <GlobalConfirmModal />
      <SignPopup />
      <ProcessProgressBar />
    </div>
  );
}
